import { FC } from 'react';
import { withStyles, WithStyles, createStyles, ButtonBase } from '@material-ui/core';
import RemoveCircle from '@material-ui/icons/HighlightOff';
import AddCircle from '@material-ui/icons/AddCircle';
import { Label } from 'components/shadcn/label';
import { withConfig, Theme } from '../../../config/';

const styles = createStyles({
  container: {
    width: '100%',
    marginBottom: 12,
  },
  inputGroup: {
    marginLeft: 12,
    marginRight: 12,
    marginBottom: 14,
    position: 'relative',
  },
  inputWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid',
    paddingBottom: 8,
    width: '100%',
  },
  input: {
    border: 'none',
    outline: 'none',
    flex: 1,
    fontSize: 14,
    fontFamily: 'Roboto',
    background: 'transparent',
  },
  removeButtonContainer: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  addButtonWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 8,
  },
});

interface Props extends WithStyles<typeof styles> {
  placeholder: string;
  label: string;
  theme: Theme;
  values: { spokenLanguages: string[] };
  onChangeLanguage: (index: number, value: string) => void;
  onRemoveLanguage: (index: number) => void;
  onAddLanguage: () => void;
}

const SpokenLanguagesInput: FC<Props> = ({
  classes,
  theme,
  values,
  label,
  placeholder,
  onChangeLanguage,
  onRemoveLanguage,
  onAddLanguage,
}) => {
  return (
    <div className={classes.container}>
      <Label className="ml-3 mb-1">{label}</Label>
      {(values.spokenLanguages || []).map((language, index) => (
        <div key={index} className={classes.inputGroup}>
          <div className={classes.inputWrapper} style={{ borderColor: theme.BACKGROUND_SECONDARY }}>
            <input
              type="text"
              value={language}
              className={classes.input}
              style={{ color: theme.TEXT_PRIMARY }}
              placeholder={placeholder}
              onChange={(e) => onChangeLanguage(index, e.target.value)}
            />
            <div className={classes.removeButtonContainer}>
              <ButtonBase
                style={{
                  borderRadius: 20,
                  fontSize: 30,
                  background: theme.BACKGROUND,
                }}
                onClick={() => onRemoveLanguage(index)}
              >
                <RemoveCircle style={{ color: theme.BUTTON_SECONDARY }} fontSize="inherit" />
              </ButtonBase>
            </div>
          </div>
        </div>
      ))}
      <div className={classes.addButtonWrapper}>
        <ButtonBase
          disabled={
            values.spokenLanguages.length > 0 && !values.spokenLanguages[values.spokenLanguages.length - 1].trim()
          }
          style={{
            borderRadius: 50,
            fontSize: 40,
            background: theme.BACKGROUND,
          }}
          onClick={onAddLanguage}
        >
          <AddCircle
            style={{
              color:
                values.spokenLanguages.length === 0 || values.spokenLanguages[values.spokenLanguages.length - 1].trim()
                  ? theme.BUTTON_PRIMARY
                  : theme.BACKGROUND_SECONDARY,
            }}
            fontSize="inherit"
          />
        </ButtonBase>
      </div>
    </div>
  );
};

export default withStyles(styles)(withConfig(SpokenLanguagesInput));
